import { SECONDS } from './time';

export const SUBSCRIPTION_VARIANTS = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual'
};

export const SUBSCRIPTION_STATUS = {
  PENDING: 'pending',
  AUTHORIZED: 'authorized',
  PAUSED: 'paused',
  CANCELLED: 'cancelled'
};

export const SUBSCRIPTION_PLANS = {
  BASIC: 'basic',
  PREMIUM: 'premium'
};

export const WORKSPACE_STATUS = {
  NORMAL: 'normal',
  FREE_TRIAL: 'freeTrial',
  FREE_TRIAL_ENDING: 'freeTrialEnding',
  FREE_TRIAL_OVER: 'freeTrialOver',
  SUBSCRIPTION_CANCELLED: 'subscriptionCancelled',
  SUBSCRIPTION_PAUSED: 'subscriptionPaused',
  SUBSCRIPTION_OVER: 'subscriptionOver'
};

export const DISABLED_WORKSPACE_STATUSES = [
  WORKSPACE_STATUS.SUBSCRIPTION_PAUSED,
  WORKSPACE_STATUS.SUBSCRIPTION_OVER,
  WORKSPACE_STATUS.FREE_TRIAL_OVER
];

export const PAID_SUBSCRIPTION_STATUSES = [WORKSPACE_STATUS.NORMAL, WORKSPACE_STATUS.SUBSCRIPTION_PAUSED];

export const FREE_TRIAL_STATUSES = [
  WORKSPACE_STATUS.FREE_TRIAL,
  WORKSPACE_STATUS.FREE_TRIAL_ENDING,
  WORKSPACE_STATUS.FREE_TRIAL_OVER
];

export const CREATE_SUBSCRIPTION_DELAY = 2 * SECONDS;

// Plan identifiers (used for translations and feature gates). Packages, prices and limits come from the backend:
// see #hooks/queries/useSubscriptionCatalog
export const SEAT_PLANS = SUBSCRIPTION_PLANS;

// Backend internal code when the workspace has no free seats for a new member
export const SEATS_LIMIT_INTERNAL_CODE = '1209';

// Max users (owner included) of a workspace in its free trial. Keep in sync with the backend
export const FREE_TRIAL_MAX_USERS = Number(process.env.REACT_APP_FREE_TRIAL_MAX_USERS) || 4;

export const IVA_RATE = 0.21;

export const MONTHS_PER_YEAR = 12;

// TODO: define the annual discount with the business team (0 = annual is 12 monthly payments)
export const ANNUAL_DISCOUNT = 0;
